import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IEbayAspectsResponse } from "../models/EbayOffer";

export default function useEbayAspects(categoryId: string) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60 * 60; // 1 hour

  const aspects = useQuery({
    queryKey: ["ebayAspects", categoryId],
    queryFn: () =>
      get<IEbayAspectsResponse>(
        `/ebay/aspects?${categoryId ? `query=${categoryId}` : ""}`
      ).then((res) => res.data),
    enabled: !!categoryId,
    staleTime: staleTime,
  });

  return {
    aspects,
  };
}
